import React from 'react';
import { colorOf } from './areas';

/**
 * An area in a dropdown, with its colour beside it.
 *
 * 2026-08-30: "at edit and add can we show like a color coded dot in the end?".
 *
 * The same colour the booking board, the laundry sheet and the coverage map use
 * for that area — one list, so a dot here can never disagree with a card there.
 * Pass it to react-select as formatOptionLabel.
 */
export function formatAreaOption(option) {
    return (
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
            <span>{option.label}</span>
            <span
                aria-hidden="true"
                style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    flex: '0 0 auto',
                    background: colorOf(option.value),
                }}
            />
        </span>
    );
}
